import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper';

import {
    ACTION_SET_THEME,
    ACTION_THEME_CLEAR,
    ThemeAction,
} from '../actions/theme';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";

export interface IThemeState {
    light: boolean
}

const initialState: IThemeState = {
    light: true
};


function _loading(state: IThemeState, _isLoading: boolean): IThemeState {
    const newState: IThemeState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function setTheme(state: IThemeState,
    light: boolean
): IThemeState {
    const newState: IThemeState = update(state, {
        light: {
            $set: light
        }
    });

    return newState;
}

function clear(state: IThemeState, propertiesToClear?: string[]): IThemeState {

    if (!propertiesToClear) {
        const newState: IThemeState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}
const ThemeReducer: Reducer<IThemeState> = (state: IThemeState = initialState, action: ThemeAction) => {
    switch (action.type) {
        case ACTION_THEME_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_SET_THEME:
            return setTheme(state, action.light);
    }

    return state;
}

export default ThemeReducer;